/* eslint-disable */
import Swiper, { Pagination } from 'swiper';
Swiper.use(Pagination);

export default {
  init(selector) {
    new Swiper(selector, {
      spaceBetween: 15,
      pagination: {
        el: '.features__pagination',
        clickable: true
      }
    });
  }
};
